export const SEND_STATUS = [
  { value: 'Success', label: 'Success' },
  { value: 'Failed', label: 'Failed' },
  { value: 'Pending', label: 'Pending' }
]
export const SEND_STATUS_UPPER = [
  { value: 'SUCCESS', label: 'Success' },
  { value: 'FAILED', label: 'Failed' },
  { value: 'PENDING', label: 'Pending' }
]
export const ACTIVE_STATUS = [
  { value: 'Active', label: 'Active' },
  { value: 'Disabled', label: 'Disabled' }
]

export const NFC_SKU_STATUS = [
  { value: 'Active', label: 'Active' },
  { value: 'Inactive', label: 'Inactive' }
]

export const CONFIG_STATUS = [
  { value: true, label: 'Enabled' },
  { value: false, label: 'Disabled' }
]

export const EMAIL_MANAGEMENT_STATUS = [
  { value: 'Active', label: 'Enabled' },
  { value: 'InActive', label: 'Disabled' }
]

export const PLANT_CODE = [
  { value: '1025', label: '1025' },
  { value: '1027', label: '1027' },
  { value: '1028', label: '1028' },
  { value: '1039', label: '1039' },
  { value: '1078', label: '1078' },
  { value: '1094', label: '1094' },
  { value: '1201', label: '1201' },
  { value: '1202', label: '1202' },
  { value: '1203', label: '1203' },
  { value: '1204', label: '1204' },
  { value: '1210', label: '1210' },
  { value: '1213', label: '1213' }
]

export const SYSTEM_LIST = [
  { value: 'runbow', label: 'SKU_NOTIFICATION_runbow' },
  { value: 'baozun', label: 'SKU_NOTIFICATION_baozun' },
  { value: 'yhglobal', label: 'SKU_NOTIFICATION_yhglobal' },
  { value: 'maersk', label: 'SKU_NOTIFICATION_maersk' }
]

export const BUSINESS_TYPE = [
  { value: '1', label: 'IB – Factory' },
  { value: '3', label: 'IB – STO' },
  { value: '4', label: ' IB – RSO' },
  { value: '2', label: 'OB' }
]
export const CARTON_PE = [
  { value: 'FTW', label: 'FTW' },
  { value: 'APP', label: 'APP' },
  { value: 'EQP', label: 'EQP' }
]
export const DIVISION = [
  { value: '10', label: 'APP' },
  { value: '20', label: 'FTW' },
  { value: '30', label: 'EQP' }
]
export const RETAG_LIST = [
  { value: 'Y', label: 'Y' },
  { value: 'N', label: 'N' }
]
export const RETAG_LIST2 = [
  { value: '1', label: 'Y' },
  { value: '0', label: 'N' }
]
export const CSC_REPORT_TYPE = [
  { value: '1', label: 'TO-B' },
  { value: '2', label: 'TO-C' }
]
export const BUSINESS_TYPE_REWORK = [
  { value: '1', label: 'IB' },
  { value: '2', label: 'OB' }
]
export const SITE_TYPE = [
  { value: 'PLANT', label: 'Plant' },
  { value: 'STORE', label: 'Store' }
]
export const SITE_STATUS = [
  { value: 1, label: 'Enabled' },
  { value: 2, label: 'Canceled' }
]

export const REWORK_CHECK_RESULT_STATUS = [
  { value: '1', label: '准确' },
  { value: '2', label: 'EPC多件' },
  { value: '3', label: 'EPC少件' },
  { value: '4', label: 'UPC混件' },
  // { value: '5', label: '未知箱号' },
  { value: '6', label: '人工确认' },
  { value: '7', label: '新箱' }
]

export const SPECIAL_TYPE_RECORD_STATUS = [
  { value: 0, label: 'Active' },
  { value: 1, label: 'Disabled' }
]
